export default __webpack_public_path__ + "static/media/3876.3d461cff.png";